import { render, staticRenderFns } from "./Company_information.vue?vue&type=template&id=32f9c948&scoped=true&"
import script from "./Company_information.vue?vue&type=script&lang=js&"
export * from "./Company_information.vue?vue&type=script&lang=js&"
import style0 from "./Company_information.vue?vue&type=style&index=0&id=32f9c948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9c948",
  null
  
)

export default component.exports